
import { Component, Vue, Prop } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';

import VehicleUsages from '../../vehicle-usage/VehicleUsages.vue';
import VehicleMonthlyMileageChart from '../../../manager/report/VehicleMonthlyMileageChart.vue';
import VehicleMonthlyConsumptionChart from '../../../manager/report/VehicleMonthlyConsumptionChart.vue';
import { deleteResource, getResources } from '../../../../../framework/client/resource';
import { VehicleContractFillRequest } from '../../../../../../common/application/model/VehicleContractFillRequest';
import { errorToast, successToast } from '../../../../service/toast_service';
import EmailField from '../../../../../framework/fields/EmailField.vue';
import { ValidationObserver } from 'vee-validate';
import { apiPost } from '../../../../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../../../../common/framework/constants';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import VehicleMonthlyCO2Chart from '../../../manager/report/VehicleMonthlyCO2Chart.vue';
import VehicleMonthlyAverageMileageChart from '../../../manager/report/VehicleMonthlyAverageMileageChart.vue';
import { dateToUiDateTimeString } from '../../../../../../common/framework/util/convert';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import { OptionValue } from '../../../../../framework/service/options';

@Component({
    components: {
        SelectField,
        ValidationObserver,
        EmailField,
        VehicleUsages,
        VehicleMonthlyMileageChart,
        VehicleMonthlyConsumptionChart,
        VehicleMonthlyCO2Chart,
        VehicleMonthlyAverageMileageChart,
    },
})
export default class VehicleContractFillRequests extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_CONTRACT_FILL_REQUEST;
    @Prop(String) readonly vehicleContractId!: string;
    @Prop(Boolean) readonly isDraftMode!: boolean;

    shared = sharedState;

    local = {
        showAddEmailForm: false,
        addEmailForm: {
            email: '',
            locale: 'fi',
        },
        selected: null as VehicleContractFillRequest | null,
        rows: [] as VehicleContractFillRequest[],
        localeOptions: [
            {
                label: 'Suomi',
                id: 'fi',
            },
            {
                label: 'English',
                id: 'en',
            },
        ] satisfies OptionValue[],
    };

    mounted() {
        this.loadAsyncData();
    }

    private async loadAsyncData(): Promise<void> {
        const parameters = new Map<string, any>([['vehicleContractId', this.vehicleContractId]]);
        this.local.rows = await getResources<VehicleContractFillRequest>(this.resourceType, -1, parameters);
    }

    add() {
        if (!this.isDraftMode) {
            this.$buefy.toast.open({
                message: this.$t('message.vehicleContractIsNotInDraftMode').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
            return;
        }
        this.local.showAddEmailForm = !this.local.showAddEmailForm;
    }

    confirmDelete() {
        this.$buefy.dialog.confirm({
            title: this.$t('title.confirmDelete').toString(),
            message: this.$t('message.confirmDelete').toString(),
            cancelText: this.$t('button.cancel').toString(),
            confirmText: this.$t('button.ok').toString(),
            type: 'is-success',
            onConfirm: async () => {
                if (this.local.selected) {
                    try {
                        await deleteResource(this.resourceType, this.local.selected.id);
                        successToast(this, 'message.resourceDeleted');
                        await this.loadAsyncData();
                    } catch (e) {
                        errorToast(this);
                    }
                }
            },
        });
    }

    async save() {
        if (this.local.rows.map((x) => x.receiverEmail).includes(this.local.addEmailForm.email)) {
            this.$buefy.toast.open({
                message: this.$t('message.emailAlreadyExists').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
            return;
        }
        await this.createFillRequest(
            this.vehicleContractId,
            this.local.addEmailForm.email,
            this.local.addEmailForm.locale,
        );
        this.$buefy.toast.open({
            message: this.$t('message.emailSent').toString(),
            type: 'is-success',
            position: 'is-top',
        });

        this.local.showAddEmailForm = false;
        this.local.addEmailForm.email = '';
        await this.loadAsyncData();
    }

    async createFillRequest(vehicleContractId: string, email: string, locale: string) {
        const response = await apiPost(`/api/admin/vehicle-contract/${vehicleContractId}/fill-request`, {
            email,
            locale,
        });
        if (response.status === 200) {
            return (await response.json()) as VehicleContractFillRequest;
        } else {
            throw new Error(ERROR_API_CALL_FAILED);
        }
    }

    dateTimeToString(timestamp: Date | string) {
        return dateToUiDateTimeString(typeof timestamp === 'string' ? new Date(timestamp) : timestamp);
    }
}
